import { useGetClientUser } from '~/hooks';
import { EditUserFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof EditUserFormPresentation>;

type Args = {
  data: ReturnType<typeof useGetClientUser>['data'];
};

type IConvertToPresentationProps = (
  args: Args
) => Pick<PresentationProps, 'fullName' | 'isBillableFromEditable'>;

/**
 * API レスポンスの利用者データを Presentation Props に変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const { user } = data;
  return {
    fullName: user.full_name,
    isBillableFromEditable: user.is_billable_from_editable,
  };
};
